import LegalPolicyPage from './LegalPolicyPage';
export default function NoRefundPolicy() {
  return <LegalPolicyPage slug="no-refund-policy" fallbackTitle="No Refund Policy" />;
}
